// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const fetchReportMenu = createAction('[Custom PDF Report Modal] Fetch Report Menu');
export const setReportMenuFetchSuccess = createAction('[Custom PDF Report Modal] Set Report Menu Fetch Success', props());
export const setReportMenuFetchFailure = createAction('[Custom PDF Report Modal] Set Report Menu Fetch Failure', props());
export const deleteReport = createAction('[Custom PDF Report Modal] Delete PDF Report', props());
export const setCurrentReportTypeIndex = createAction('[Custom PDF Report Modal] Set Current Report Type Index', props());
export const setCurrentReportIndex = createAction('[Custom PDF Report Modal] Set Current Report Index', props());
